export default __webpack_public_path__ + "static/media/galeria-drivr3.78ce6088.JPG";